import React from 'react';
import { Link } from 'react-router-dom';
import './BRCCertificate.css';

const BRCCertificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Product Certification</div>
            <h1 className="page-title">BRC Certificate</h1>
            <div className="page-text-content">
              <p>
                Hello Valued Visitors,
              </p>
              <p>
                We, NQC (Nova Quality Certification Agency), are pleased to share details about the 
                BRC Certification, one of the comprehensive certification and accreditation services 
                we offer.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is the BRC Certification?</h2>
            <div className="page-text-content">
              <p>
                BRC represents a food safety and quality standard developed by the British Retail 
                Consortium. The BRC Certification is a document that verifies compliance with 
                high-level food safety and quality standards for food producers, processing facilities, 
                and retailers.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should I Get the BRC Certification?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Food Safety</h3>
                <p className="reason-description">
                  The BRC Certification demonstrates your compliance with food safety standards, 
                  reassuring consumers that you provide reliable and safe products.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Market Image</h3>
                <p className="reason-description">
                  Having the BRC Certification emphasizes your commitment to food safety, helping you 
                  establish a strong market image.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. International Acceptance</h3>
                <p className="reason-description">
                  BRC is a respected certification globally, opening doors to market your products 
                  worldwide.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Competitive Advantage</h3>
                <p className="reason-description">
                  Having the BRC Certification sets you apart from competitors, attracting customers 
                  and aiding in business growth.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How Does the Process Work to Obtain the BRC Certification?</h2>
            <div className="page-text-content">
              <p>
                To obtain the BRC Certification, you need to demonstrate that your business meets 
                specific standards. This process involves the evaluation, certification, and, if 
                necessary, corrective measures for your facility. NQC (Nova Quality Certification 
                Agency) can assist you throughout the BRC certification process to ensure successful 
                completion.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) has extensive experience in food safety and 
                quality certification. Our expert team provides tailored solutions to meet your 
                business needs and ensures a smooth certification process.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                The BRC Certification symbolizes trust and quality in the food industry. We at NQC 
                (Nova Quality Certification Agency) take pride in helping your business achieve this 
                prestigious certification. Feel free to contact us for more information or to ask any 
                questions.
              </p>
              <p>
                Best regards,
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default BRCCertificate;

